import { render } from "./BaseDashboardSection.vue?vue&type=template&id=79596af3&scoped=true"
const script = {}

import "./BaseDashboardSection.vue?vue&type=style&index=0&id=79596af3&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79596af3"]])

export default __exports__